import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { CollectioncategoryCollectiontypeSchema } from '../CollectioncategoryTypeSchema';
import { CollectioncategoryTypeMappingListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import collectionCategoryService from '../../CollectionCategory/services';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'COLLECTIONCATEGORYTYPEMAPPING'

export function CollectioncategoryTypeMapping(props) {

    const [title, setTitle] = useState("Collection Type to Collection Category");
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [product, setProduct] = useState([]);
    const [collectionCatagory, setCollectionCatagory] = useState([]);
    const [collectioncategoryTypeMappingData, setCollectioncategoryTypeMappingData] = useState([]);
    const [collectioncategoryTypeMapping, setCollectioncategoryTypeMapping] = useState({
        groupID: '0',
        operationEntityID: '0',
        productID: '0',
        collectionCategoryID: '0'
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(CollectioncategoryCollectiontypeSchema).options({ allowUnknown: true });


    useEffect(() => {
	trackPromise(
        getPermissions()
	)
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
            )
    }, [collectioncategoryTypeMapping.groupID])

    useEffect(() => {
        trackPromise(
            getProductsForDropDown()
            )
        handleSearch();
    }, [collectioncategoryTypeMapping.operationEntityID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
            )
    }, [collectioncategoryTypeMapping.productID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCOLLECTIONCATEGORYTYPELISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITCOLLECTIONCATEGORYTYPE');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setCollectioncategoryTypeMapping({
            ...collectioncategoryTypeMapping,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        
        getGroupsForDropdown();
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(collectioncategoryTypeMapping.groupID);
        setOperationEntity(opEntities);
    }

    async function getProductsForDropDown() {
        const products = await services.getAvialableProducts(collectioncategoryTypeMapping.operationEntityID);
        setProduct(products);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCatagories = await collectionCategoryService.GetCollectionCategoryByOperationEntityID(collectioncategoryTypeMapping.operationEntityID);
        setCollectionCatagory(collectionCatagories);
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, CollectioncategoryCollectiontypeSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setCollectioncategoryTypeMapping({
            ...collectioncategoryTypeMapping,
            [e.target.name]: value
        });
        setErrors(error);
    }

    async function handleSearch(e) {
        if(e !== undefined){
            const errorMessages = validate(schema, collectioncategoryTypeMapping);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.getOperationentityCollectionCatagoryFilterData(collectioncategoryTypeMapping.collectionCategoryID);
        setCollectioncategoryTypeMappingData(response);
    }

    async function editCollectioncategoryTypeMapping(data) {
        props.history.push({
            pathname: 'collectioncategorytypemapping/AddEdit',
            data: data,
            edit: true
        });
    }

    function clearState() {
        setCollectioncategoryTypeMapping({
            ...collectioncategoryTypeMapping,
            groupID: '0',
            operationEntityID: '0',
            productID: '0',
            collectionCategoryID: '0'
        });
        setCollectioncategoryTypeMappingData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    path="collectioncategorytypemapping/AddEdit"
                                    buttonText="Add Collectioncategory Collectiontype Mapping"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={collectioncategoryTypeMapping.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={collectioncategoryTypeMapping.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="productID">Product</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="productID"
                                            id="productID"
                                            name="productID"
                                            value={collectioncategoryTypeMapping.productID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Product--</MenuItem>
                                            {generateDropDownMenu(product)}
                                        </Select>
                                        {errors["productID"] && <FormHelperText error>{errors["productID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionCategoryID">Collection Category</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionCategoryID"
                                            id="collectionCategoryID"
                                            name="collectionCategoryID"
                                            value={collectioncategoryTypeMapping.collectionCategoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select collection category--</MenuItem>
                                            {generateDropDownMenu(collectionCatagory)}
                                        </Select>
                                        {errors["collectionCategoryID"] && <FormHelperText error>{errors["collectionCategoryID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, collectioncategoryTypeMapping)}
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={(e) => handleSearch(e)}
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                                <CollectioncategoryTypeMappingListing collectioncategoryTypeMappingData={collectioncategoryTypeMappingData} handleClick={editCollectioncategoryTypeMapping} />

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}